<template>
    <b-card>
        <b id="printable" style="display: none;font-weight: bold; font-size: 22px;line-height: 400%;">ISO 14001:2015 ÇYS İç Denetim Raporu</b>
        <b-modal ref="ticketTypeRef" size="sm" hide-footer hide-header centered>
            <div class="d-block text-center">
                <b-row class="mt-1">
                    <b-col>
                        <b-form-select cols="6" v-model="ticketType" :options="this.gbId(this.$store.state.user.customerId) ? ticketTypesGaranti: ticketTypes" @change="showCreateTicketModal($event)"></b-form-select>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-row align-h="between">
            <b-col class="mt-2" style="text-align: left">
                <div @click="routeToDashboard(selectedSite.id, year)" style="font-weight: bold; font-size: 1.2em; align-self: center; cursor: pointer">{{selectedSite.name}} - {{ $t('headerTitle') }}</div>
            </b-col>
            <b-col cols="9" sm="9" md="7" lg="5" xl="6">
                <b-row align-h="end">
                    <b-col v-if="this.$store.state.user.permissions.canStartAudits" class="mt-1">
                        <td class="non-printable" @click="$refs.ticketTypeRef.show()" colspan="5" style="cursor: pointer">
                            <i class="fas fa-plus-circle fa-2x"></i>
                        </td>
                    </b-col >
                    <year-select @onchange="onYearChange"/>
                    <site-multi-select
                        :selectedSiteId="selectedSite.id"
                        :givenSites="filteredSites"
                        :allowEmpty="true"
                        @oninput="selectSite"
                    />
                </b-row>
            </b-col>
        </b-row>
        <b-row style="height: 125px; background-color: white;" no-gutters>
            <b-col v-if="selectedSite">
                <b-row class="info-card-site">
                    {{ $t('isOpen') }}
                </b-row>
                <b-row align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    {{ (selectedSite.isOpen == 1) ? $t('siteOpen') : $t('siteClosed')  }}
                </b-row>
            </b-col>
            <b-col v-if="selectedSite">
                <b-row class="info-card-site">
                    {{ $t('cityTitle') }}
                </b-row>
                <b-row align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    {{ cityCodeToDisplayName }}
                </b-row>
            </b-col>
            <b-col>
                <b-row class="info-card-site">
                    {{ $t('regionTitle') }}
                </b-row>
                <b-row align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    {{ groupDisplayName }}
                </b-row>
            </b-col>
            <b-col v-if="selectedSite">
                <b-row class="info-card-site">
                    {{ $t(this.getGroupName('agent')) }}
                </b-row>
                <b-row align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    <div v-if="selectedSite.agents">
                        <span v-for="(agent,index) in selectedSite.agents" :key="index">
                            <router-link :to="{name: 'user-profile', params: {user_id: selectedSite.agentIds[index]}}">{{ agent ? agent : '-' }} </router-link>
                        </span>
                    </div>
                    <div v-else>
                        -
                    </div>
                </b-row>
            </b-col>
            <b-col v-if="selectedSite">
                <b-row class="info-card-site">
                    <template v-if="this.isbId(this.$store.state.user.customerId)"><span>{{ $t('technician') }}</span></template>
                    <template v-else><span>{{ $t('sub-agent') }}</span></template>
                </b-row>
                <b-row align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    <div v-if="selectedSite.subAgents">
                        <span v-for="(subAgent,index) in selectedSite.subAgents" :key="index">
                            <router-link :to="{name: 'user-profile', params: {user_id: selectedSite.subAgentIds[index]}}">{{ subAgent ? subAgent : '-' }} </router-link>
                        </span>
                    </div>
                    <div v-else>
                        -
                    </div>
                </b-row>
            </b-col>
            <b-col v-if="selectedSite">
                <b-row class="info-card-site">
                    {{ $t(this.getGroupName('supervisor')) }}
                </b-row>
                <b-row align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    <div v-if="selectedSite.supervisors">
                        <span v-for="(supervisor,index) in selectedSite.supervisors" :key="index">
                            <router-link :to="{name: 'user-profile', params: {user_id: selectedSite.supervisorIds[index]}}">{{ supervisor ? supervisor : '-' }} </router-link>
                        </span>
                    </div>
                    <div v-else>
                        -
                    </div>
                </b-row>
            </b-col>
            <b-col v-if="selectedSite">
                <b-row class="info-card-site">
                    {{ $t('manager') }}
                </b-row>
                <b-row align-h="center" style="color: #707070; margin-top: 10px; font-size: 1rem;">
                    <div v-if="selectedSite.directors">
                        <span v-for="(director,index) in selectedSite.directors" :key="index">
                            <router-link :to="{name: 'user-profile', params: {user_id: selectedSite.directorIds[index]}}">{{ director ? director : '-' }} </router-link>
                        </span>
                    </div>
                    <div v-else>
                        -
                    </div>
                </b-row>
            </b-col>
        </b-row>
        <div class="table-responsive mt-5" style="margin-top: 15px;overflow-y:hidden;">
            <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em">
                <thead>
                    <tr>
                        <th style="width: 1em;"></th>
                        <th style="width: 9em;">{{ $t('nonconformity') }}</th>
                        <th style="width: 10em;">{{ $t('auditDateColumn') }}</th>
                        <th style="width: 10em;">{{ $t('statusColumn') }}</th>
                        <th style="width: 10em;">{{ $t('ticketType') }}</th>
                    </tr>
                </thead>
                <tbody id="tbody">
                    <tr v-for="ticket in configureTicketList(tickets)" :id="`row_${ticket.id}_${ticket.isDetail}`" v-bind:class="{ hide_detail: ticket.isDetail&&!openDetailList.includes(ticket.id), show_detail: openDetailList.includes(ticket.id) }">
                        <td v-if="!ticket.isDetail" v-bind:class="{open_detail_arrow : openDetailList.includes(ticket.id), close_detail_arrow : !openDetailList.includes(ticket.id)}" style="font-size: 40px;font-weight:bold;width:50px; cursor: pointer;" @click="detailToggle(ticket)">&#187;</td>
                        <td v-if="!ticket.isDetail && ticket.ticketType == 'Audit'" class="titleOfRow" @click="routeToTicketDetail(ticket)"> {{(ticket.scope) ? ticket.scope : "-"}}</td>
                        <td v-if="!ticket.isDetail && ticket.ticketType == 'Action'" class="titleOfRow" @click="routeToTicketDetail(ticket)">{{(ticket.textInput) ? ticket.textInput : "-"}}</td>
                        <td v-if="!ticket.isDetail">{{ticket.auditDate | formatDate('YYYY-MM-DD') }}</td>
                        <td v-if="!ticket.isDetail">{{retrieveTicketStatus(ticket.state)}}</td>
                        <td v-if="!ticket.isDetail"> {{(ticket.ticketType) ? $t(ticketTypeOptions(ticket.ticketType)) : "-"}} </td>
                        <td v-else colspan="5" style="padding-left:13.2%; text-align: left;" >
                                <b-row>
                                    <b-col sm="6">
                                        <b-row class="my-1">
                                            <b-col sm="5" style="text-align: left; font-weight: bold; align-self: center">
                                                <label>{{$t('ticketType')}}:</label>
                                            </b-col>
                                            <b-col sm="7" style="text-align: left; right: 20px;">
                                                {{ $t(ticketTypeOptions(ticket.ticketType)) }}
                                            </b-col>
                                        </b-row>
                                        <b-row class="my-1">
                                            <b-col sm="5" style="text-align: left; font-weight: bold; align-self: center">
                                                <label>{{ $t('predictedDate') }}:</label>
                                            </b-col>
                                            <b-col sm="7" style="text-align: left; right: 20px;">
                                                <el-date-picker
                                                    v-model="ticket.expectedDate"
                                                    type="date"
                                                    :readonly="true"
                                                    format="dd/MM/yyyy"
                                                    style="width: 100%;"
                                                />
                                            </b-col>
                                        </b-row>
                                        <b-row class="my-1">
                                            <b-col sm="5" style="text-align: left; font-weight: bold; align-self: center">
                                                <label>{{$t('status')}}:</label>
                                            </b-col>
                                            <b-col sm="7" style="text-align: left; right: 20px;">
                                                {{retrieveTicketStatus(ticket.state)}}
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-row v-for="(member, index) in ticket.originalMembers" :key="index" class="my-1">
                                            <b-col sm="5" style="text-align: left; font-weight: bold; align-self: center; text-indent: 20px;">
                                                <label>{{ $t(member.type) }}:</label>
                                            </b-col>
                                            <b-col sm="7" style="text-align: left; text-indent: -5px;">
                                                <label>{{ `${member.firstName} ${member.lastName}` }}</label>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <TicketDetailCard pageType="list" :auditType="ticket.ticketType" :selectedSiteId="selectedSite.id" :ticketId="ticket.id" v-if="ticket" :ticket="ticket" :isPostsEmpty="ticket.posts.length == 0" :updateFunction="retrieveTickets"></TicketDetailCard>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </b-card>
</template>

<script>
import moment from 'moment';
import uuid from 'uuid/v4';
import Multiselect from 'vue-multiselect';
import _ from 'lodash';
import SiteCard from '../../../components/SiteCard';
import YearSelect from '../../../components/YearSelect';
import SiteMultiSelect from '../../../components/SiteMultiSelect';
import TicketDetailCard from '../../../components/TicketDetailCard';

export default {
    name: 'TicketList',
    components: {
        SiteMultiSelect,
        YearSelect,
        SiteCard,
        Multiselect,
        TicketDetailCard
    },
    data() {
        return {
            tickets: [],
            ticket: null,
            openDetailList: [],
            ticketTypes: [
                {
                    value: null,
                    text: this.$t('auditTitle'),
                    disabled: true
                },
                {
                    value: 1,
                    text: this.$t('auditType')
                },
                {
                    value: 2,
                    text: this.$t('actionType')
                }
            ],
            ticketTypesGaranti: [
                {
                    value: null,
                    text: this.$t('auditTitle'),
                    disabled: true
                },
                {
                    value: 1,
                    text: this.$t('auditTypeGaranti')
                },
                {
                    value: 2,
                    text: this.$t('actionTypeGaranti')
                }
            ],
            ticketType: null,
            filteredSites: this.$store.state.sites, // Workaround for multi-select plugin
            backdoor: 0
        };
    },
    methods: {
        configureTicketList(tickets) {
            return _.reduce(
                tickets,
                (result, element) => {
                    result = [
                        ...result,
                        {...element, isDetail: false},
                        {...element, isDetail: true}
                    ];
                    return result;
                },
                []
            );
        },
        firstExtendedDate(ticket) {
            let extendedDates = _.map(ticket.posts, 'extendedDate');
            // returns valid date : if there isn't any extended date, returns expected date.
            let selectedDate = extendedDates[Object.keys(extendedDates).length - 1]
                ? moment(extendedDates[Object.keys(extendedDates).length - 1]).format('YYYY-MM-DD')
                : '-';
            return selectedDate;
        },
        routeToTicketDetail(ticket) {
            this.$router.push({
                name: 'ticket-detail',
                params: {site_id: this.selectedSite.id, ticket_id: ticket.id}
            });
            return Promise.resolve();
        },
        detailToggle(ticket) {
            this.ticket = ticket;
            if (this.openDetailList.includes(ticket.id)) {
                this.openDetailList = _.filter(this.openDetailList, e => {
                    return e !== ticket.id;
                });
            } else {
                this.openDetailList.push(ticket.id);
            }
        },
        retrieveTicketStatus(state) {
            let status = state == 0 ? this.$t('openTicket') : this.$t('closedTicket');
            return status;
        },
        showCreateTicketModal(target) {
            // if value of dropdown item(target) equals 1 , it is audit ticket. Otherwise it is action ticket.
            if (target == 1) {
                this.$store.commit('SET_MODAL', {
                    eventId: uuid(),
                    type: 'createTicket',
                    payload: {
                        siteId: this.selectedSite.id,
                        ticketType: 'Audit'
                    }
                });
                this.$nextTick(() => {
                    this.ticketType = null;
                    this.$root.$emit('bv::show::modal', 'createTicket', target);
                    this.$eventHub.$once(this.$store.state.modal.eventId, newTicket => {
                        if (this.year === moment().year()) {
                            this.tickets.push(newTicket);
                        }
                    });
                });
            } else if (target == 2) {
                this.$store.commit('SET_MODAL', {
                    eventId: uuid(),
                    type: 'createTicket',
                    payload: {
                        siteId: this.selectedSite.id,
                        ticketType: 'Action'
                    }
                });
                this.$nextTick(() => {
                    this.ticketType = null;
                    this.$root.$emit('bv::show::modal', 'createAction', target);
                    this.$eventHub.$once(this.$store.state.modal.eventId, newTicket => {
                        if (this.year === moment().year()) {
                            this.tickets.push(newTicket);
                        }
                    });
                });
            }
            this.$refs.ticketTypeRef.hide();
        },
        // Callback for site selector
        selectSite(site) {
            this.selectedSite = site;
            this.$store.state.siteId = site ? _.get(site, "id") : null;
            if (site) {
                this.$router.push({
                      name: 'ticket-list',
                      params: {site_id: _.get(this.selectedSite, "id")},
                      query: {start_date: this.year}
                  })
            } else {
                this.selectedSite = null;
                this.$router.push({name: 'audit', query: {year: this.year}});
            }
            this.backdoor++;
            this.retrieveTickets();
        },

        retrieveTickets() {
            this.$Progress.start();
            return this.axios
                .get(`/${this.selectedSite.id}/audits?start_date=${this.year}`)
                .then(({data}) => {
                    this.tickets = data;
                    _.each(this.tickets, ticket => {
                        ticket.actionCheckList = ticket.scope;
                        let actions = '';
                        try {
                            _.each(JSON.parse(ticket.scope), (actionCheck, actionIndex) => {
                                if (actionCheck) {
                                    actions +=
                                        '→ ' +
                                        this.$t(this.$store.state.nonconformances[actionIndex - 1].action) +
                                        '\n';
                                }
                            });
                            ticket.scope = actions;
                        } catch (error) {
                            console.error(error);
                        }
                    });
                    this.$Progress.finish();
                });
        },

        onYearChange(newYear) {
            this.$store.state.year = newYear;
            this.$Progress.start();
            this.$router.push({
                name: 'ticket-list',
                params: {site_id: this.selectedSite.id},
                query: {start_date: this.year}
            });
            this.retrieveTickets().then(() => {
                this.$Progress.finish();
            });
        },
        ticketTypeOptions(type) {
            let returnType = null;
            if(this.gbId(this.$store.state.user.customerId)){
                type === 'Audit' ? returnType = 'AuditGaranti': returnType = 'ActionGaranti';
                return returnType;
            };
            if(!this.gbId(this.$store.state.user.customerId)){
                return type;
            };
        }
    },
    computed: {
        nonconformanceArticleText() {
            if (this.ticket.ticketType == 'Audit') {
                return _.get(
                    _.find(this.$store.state.nonconformances, {id: this.ticket.nonconformanceId}),
                    'article'
                );
            }
        },
        cityCodeToDisplayName() {
            this.backdoor;
            let found = _.find(this.$store.state.cities, {code: this.selectedSite.cityCode});
            if (found) {
                return found.name;
            } else {
                return '-';
            }
        },
        groupDisplayName() {
            this.backdoor;
            if (this.selectedSite) {
                let found = _.find(this.$store.state.siteGroups, {
                    id: this.selectedSite.siteGroupId
                });
                return found.display_name;
            } else if (this.selectedSiteGroupId) {
                let found = _.find(this.$store.state.siteGroups, {
                    id: this.selectedSiteGroupId
                });
                return found.display_name;
            } else {
                return this.$t('all');
            }
        }
    },
    created() {
        this.selectedSite = _.find(this.sites, {id: Number(this.route.params.site_id)});
        this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
        this.retrieveTickets();
    }
};
</script>

<style scoped>
.info-card-site {
    color: #707070;
    font-weight: bold;
    font-size: 1rem;
    height: 50%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}
.open_detail_arrow {
    animation-name: open_arrow_kf;
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
}
.close_detail_arrow {
    animation-name: close_arrow_kf;
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
}
.show_detail {
    animation-name: open_detail_kf;
    animation-duration: 0.7s;
    animation-fill-mode: forwards;
}
.show_detail:hover {
    background-color: white;
}
.hide_detail {
    display: none;
}
@keyframes open_arrow_kf {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(90deg);
    }
}
@keyframes close_arrow_kf {
    from {
        transform: rotate(90deg);
    }
    to {
        transform: rotate(0deg);
    }
}
@keyframes open_detail_kf {
    from {
        height: 0%;
        opacity: 0;
    }
    to {
        height: 100%;
        opacity: 1;
    }
}
@media print {
    #printable {
        display: block !important;
    }
    .non-printable {
        display: none !important;
    }
    .open_detail_arrow {
        animation-name: '';
        transform: rotate(90deg);
        position: relative;
        left: 3.5px;
    }
    .close_detail_arrow {
        animation-name: '';
    }
    .show_detail {
        animation-name: '';
    }
}
.titleOfRow {
    color: #007bff;
    cursor: pointer;
}
.titleOfRow:hover {
    font-weight: 500;
}
</style>

<i18n src="../../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "headerTitle": "DENETİM",
            "auditTitle":"Bir denetim tipi seçin",
            "auditType":"Düzeltici Aksiyon Maddesi",
            "auditTypeGaranti": "Uygunsuzluk Maddesi",
            "actionType":"Önleyici Aksiyon Maddesi",
            "actionTypeGaranti": "Aksiyon Planı",
            "auditDateColumn": "Denetim Tarihi",
            "statusColumn": "Durum",
            "openTicket": "Açık",
            "closedTicket": "Kapalı",
            "ticketType":"Denetim maddesi tipi",
            "Audit":"Düzeltici Faaliyet",
            "AuditGaranti": "Uygunsuzluk Maddesi",
            "Action":"Önleyici Faaliyet",
            "ActionGaranti":"Aksiyon Planı",
            "all": "Hepsi"
        },
        "en": {
            "headerTitle": "AUDITS",
            "auditTitle":"Choose one of the audit type",
            "auditType":"Corrective Action Type",
            "auditTypeGaranti": "Corrective Action",
            "actionType":"Preventive Action Type",
            "actionTypeGaranti": "Action Plan",
            "auditDateColumn": "Audit Date",
            "statusColumn": "Action Status",
            "openTicket": "Open",
            "closedTicket": "Closed",
            "ticketType":"Action Type",
            "Audit":"Corrective Action",
            "Action":"Preventive Action",
            "all": "All",
            "AuditGaranti": "Corrective Action",
            "ActionGaranti":"Action plan"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Audit/Audits/TicketList.vue